import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=3542c2c4&scoped=true"
import script from "./loginPage.vue?vue&type=script&lang=ts"
export * from "./loginPage.vue?vue&type=script&lang=ts"
import style0 from "./loginPage.vue?vue&type=style&index=0&id=3542c2c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3542c2c4",
  null
  
)

export default component.exports